import { InsuranceOverrideType } from './InsuranceOverrideType';

export const InsuranceOverrideTypeOptions = [
    {
        id: InsuranceOverrideType.None,
        name: 'No',
    },
    {
        id: InsuranceOverrideType.ArizonaLoan,
        name: 'Arizona Loan',
    },
    {
        id: InsuranceOverrideType.StructureValueCoverageOnly,
        name: 'Struc. Cvrg Only',
    },
    {
        id: InsuranceOverrideType.PocApprovedException,
        name: 'POC Aprvd Exc.',
    },
];
